<template>
  <v-container dark color="#241e20">
    <v-row class="mt-6 ml-3">
        <p class="text-h5 text-bold naranja">ENZYMOTERAPIA BIO-ORGANIC</p>
    </v-row>
    <v-row >
      <v-col cols="12" sm="4">
        <v-img src="img/enzymo.jpg"></v-img>
      </v-col>
      <v-col cols="12" sm="8" justify="center">
        <p class="grey--text text--lighten-2">Tratamiento 100% orgánico para alisar, eliminar el encrespamiento y recuperar la salud del cabello en una sola sesión.</p>
        <p class="grey--text text--lighten-2">Reparación total y brillo espejo para lograr una melena sana y natural.</p>
      </v-col>
    </v-row>
    <v-row class="mt-6 ml-3">
        <p class="text-h5 text-bold naranja">OLAPLEX</p>
    </v-row>
    <v-row>
      <v-col cols="12" sm="8">
        <p class="grey--text text--lighten-2">Tratamiento único exprés para restaurar la fibra de los cabellos maltratados por procesos químicos o como tratamiento complementario para reducir efectos nocivos en trabajos técnicos.</p>
      </v-col>
      <v-col cols="12" sm="4">
        <v-img src="img/Olaplex.jpg"></v-img>
      </v-col>
    </v-row>
    <v-row class="mt-6 ml-3">
        <p class="text-h5 text-bold naranja">METAL DETOX</p>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4">
        <v-img src="img/MetalDetox.jpg"></v-img>
      </v-col>
      <v-col cols="12" sm="8">
        <p class="grey--text text--lighten-2">Novedad mundial del 2021 y exclusivo en Torrent.</p>
        <p class="grey--text text--lighten-2">Tratamiento para restaurar el cabello metalizado consiguiendo resultados puros de color, evitando reflejos no deseados y protegiendo la salud del cabello ante cualquier tipo de proceso químico.</p>
      </v-col>
    </v-row>
    <v-row class="mt-6 ml-3">
        <p class="text-h5 text-bold naranja">CUERO CABELLUDO</p>
    </v-row>
    <v-row>
      <v-col cols="12" sm="8">
        <p class="grey--text text--lighten-2">Tratamiento para alteraciones del cuero cabelludo, falta de densidad, dermatitis, alopecia, seborrea y sequedad con los mejores productos del mercado y sus rituales de aplicación.</p>
        <p class="grey--text text--lighten-2">Un cabello sano comienza desde la raíz.</p>
      </v-col>
      <v-col cols="12" sm="4">
        <v-img src="img/cuero.jpg"></v-img>
      </v-col>
    </v-row>
    <v-row class="mt-6 ml-3">
        <p class="text-h5 text-bold naranja">MELENAS XXL</p>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4">
        <v-img src="img/antirotura.jpg"></v-img>
      </v-col>
      <v-col cols="12" sm="8">
        <p class="grey--text text--lighten-2">Tratamiento efecto botox para las melenas XXL con problemas de rotura, baja densidad o daños externos ocasionados por herramientas alisadoras.</p>
        <p class="grey--text text--lighten-2">Consigue el largo que deseas con nuestros cuidados.</p>
      </v-col>
    </v-row>
    <v-row class="mt-6 ml-3">
        <p class="text-h5 text-bold naranja">CAMBIOS DE FORMA</p>
    </v-row>
    <v-row>
      <v-col cols="12" sm="8">
        <p class="grey--text text--lighten-2">Enzymo… liso total, moldeados, permanentes, liso natural y relajadores de rizo.</p>
        <p class="grey--text text--lighten-2">Cualquier cambio es posible respetando la salud del cabello.</p>
      </v-col>
      <v-col cols="12" sm="4">
        <v-img src="img/CambioLook.jpg" max-height="150"></v-img>
      </v-col>
    </v-row>
    <v-row class="mt-6 ml-3">
        <p class="text-h5 text-bold naranja">NOVIAS Y EVENTOS</p>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4">
        <v-img src="img/novias.jpg"></v-img>
      </v-col>
      <v-col cols="12" sm="8">
        <p class="grey--text text--lighten-2">En los días más importantes de tu vida nos ocupamos del peinado y maquillaje para conseguir para conseguir un look total en armonía con tu vestido y personalidad.</p>
        <p class="grey--text text--lighten-2">Nos desplazamos allí donde nos necesites asistiéndote en cada momento para que todo sea perfecto.</p>
      </v-col>
    </v-row>
    <v-row class="mt-6 ml-3">
        <p class="text-h5 text-bold naranja">COLORIMETRÍA</p>
    </v-row>
    <v-row>
      <v-col cols="12" sm="8">
        <p class="grey--text text--lighten-2">Tratamientos técnicos creativos de color con el fin de conseguir tanto efectos clásicos como de últimas tendencias.</p>   
      </v-col>
      <v-col cols="12" sm="4">
        <v-img src="img/coloracion.jpg"></v-img>
      </v-col>
    </v-row>
    <v-row class="mt-6 ml-3">
        <p class="text-h5 text-bold naranja">CORTES</p>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4">
        <v-img src="img/corte.jpg"></v-img>
      </v-col>
      <v-col cols="12" sm="8">
        <p class="grey--text text--lighten-2">Diseños creativos adaptados a todos los estilos, preferencias y ritmo de vida con nuestro sello personal.</p>
      </v-col>
    </v-row>
    <v-row class="mt-6 ml-3">
        <p class="text-h5 text-bold naranja">MAQUILLAJES PROFESIONALES</p>
    </v-row>
    <v-row>
      <v-col cols="12" sm="8">
        <p class="grey--text text--lighten-2">Titulación homologada en maquillajes de día, noche, fiesta y novias respetando tu piel, tu estilo y preferencias.</p>
        <p class="grey--text text--lighten-2">Maquillaje premium, durabilidad 24h.</p>
      </v-col>
      <v-col cols="12" sm="4">
        <v-img src="img/maquillajes.jpg"></v-img>
      </v-col>
    </v-row>
    <v-row class="mt-6 ml-3">
        <p class="text-h5 text-bold naranja">VENTA DE PRODUCTOS PROFESIONALES</p>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4">
        <v-img src="img/venta.jpg"></v-img>
      </v-col>
      <v-col cols="12" sm="8">
        <p class="grey--text text--lighten-2">Venta-Consejo de productos profesionales para que en tu rutina diaria pueda seguir nuestro diagnóstico en casa,a fin de conseguir un cabello perfecto entre visitas al salón.</p>
      </v-col>
    </v-row>
    <v-row class="mt-6 ml-3">
        <p class="text-h5 text-bold naranja">PEINADOS FESTIVOS TRADICIONALES</p>
    </v-row>
    <v-row>
      <v-col cols="12" sm="8">
        <p class="grey--text text--lighten-2">Las fiestas de nuestra Comunidad nos dan la posibilidad de superarnos con creatividad, fantasía e ilusión haciéndonos partícipes de la fiesta y la alegría.</p>    
      </v-col>
      <v-col cols="12" sm="4">
        <v-img src="img/tradicional.jpg"></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Services',

    data: () => ({
      
    }),
  }
</script>
